import anime from 'animejs';

const liquorSelector = document.querySelector('.recipes__filter--liquor');
const mixerSelector = document.querySelector('.recipes__filter--mixer');
const occasionSelector = document.querySelector('.recipes__filter--occasion');
const allRecipesButton = document.querySelector('.recipes__all-recipes-btn');
const clearFiltersButton = document.querySelector('#clear-filters');

const recipesItemsArr = Array.from(document.querySelectorAll('.recipes__item'));
const noResultsContainer = document.querySelector('.recipes__no-recipes-container');

const changeFilter = () => {
    // pull values from <select> boxes; will be our de facto state
    const liquor = liquorSelector.value;
    const mixer = mixerSelector.value;
    const occasion = occasionSelector.value;

    const visibleItemArr = [];

    recipesItemsArr.map((item) => {
        // turn data-attributes from HTML to arrays
        const liquorArr = item.dataset.liquor.split(' ');
        const mixerArr = item.dataset.mixer.split(' ');
        const occasionArr = item.dataset.occasion.split(' ');

        // See if the item should be visible after the filters change;
        // if so, push them into a visibleItemsArr.
        if (
            (!liquor || liquorArr.includes(liquor)) &&
            (!mixer || mixerArr.includes(mixer)) &&
            (!occasion || occasionArr.includes(occasion))
        ) {
            visibleItemArr.push(item);
        }
    });

    // the array passed into this function will later be passed into
    // a callback to animate those items INTO view
    hideItems(visibleItemArr);
};

const clearFilters = () => {
    liquorSelector.value = '';
    mixerSelector.value = '';
    occasionSelector.value = '';
    hideItems(recipesItemsArr);
    noResultsContainer.classList.remove('recipes__no-recipes-container--visible');
};

// this will hide all items from view and then use a callback to re-populate the ones
// that should be visible (via the element passed into the argument arr)
const hideItems = (addItemArr) => {
    const items = recipesItemsArr;
    const images = items.map((item) => {
        return item.querySelector('.recipes__item-image');
    });
    anime({
        targets: images,
        translateY: 100,
        duration: 0,
        opacity: 0,
        complete: () => {
            items.forEach((item) => {
                item.classList.add('recipes__item--hidden');
            });
            images.forEach((image) => {
                image.classList.add('recipes__item-image--transition-off');
            });
            if (addItemArr.length > 0) {
                addItems(addItemArr);
            } else {
                showNoResults();
            }
        }
    });
};

const addItems = (items) => {
    items.forEach((item) => {
        item.classList.remove('recipes__item--hidden');
    });

    const images = items.map((item) => {
        return item.querySelector('.recipes__item-image');
    });

    // need a quick timeout so elements can properly find their place after
    // their display:none via .recipes__item--hidden is removed
    setTimeout(() => {
        anime({
            targets: images,
            translateY: [100, 0],
            easing: 'easeOutElastic',
            duration: 1000,
            delay: anime.stagger(100),
            complete: () => {
                images.forEach((image) => {
                    image.classList.remove('recipes__item-image--transition-off');
                });
            }
        });
        anime({
            targets: images,
            opacity: [0, 1],
            duration: 200,
            easing: 'linear',
            delay: anime.stagger(100)
        });
    }, 50);
};

const showNoResults = () => {
    noResultsContainer.classList.add('recipes__no-recipes-container--visible');
    setTimeout(() => {
        anime({
            targets: noResultsContainer,
            opacity: [0, 1],
            duration: 200,
            easing: 'linear'
        });
        anime({
          targets: noResultsContainer,
          translateY: [100, 0]
        })
    }, 50);
};

// if params are in URL, apply the filter
const queryString = window.location.search;
const params = new URLSearchParams(queryString);
const mixParam = params.get('mix');

if (mixParam && mixerSelector) {
    mixerSelector.value = mixParam;
    changeFilter();
}

// event listeners

if (liquorSelector) {
    liquorSelector.addEventListener('change', () => {
        changeFilter('liquor', changeFilter);
    });
}
if (mixerSelector) {
    mixerSelector.addEventListener('change', () => {
        changeFilter('mixer', changeFilter);
    });
}
if (occasionSelector) {
    occasionSelector.addEventListener('change', () => {
        changeFilter('occasion', changeFilter);
    });
}
if (allRecipesButton) {
    allRecipesButton.addEventListener('click', clearFilters);
}

if (clearFiltersButton) {
    clearFiltersButton.addEventListener('click', clearFilters);
}
